import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "../lib/cn";

const alertVariants = cva(cn("rounded-card p-md text-body"), {
  variants: {
    tone: {
      info: "bg-surface-container text-on-surface",
      success: "bg-primary-fixed text-on-primary-fixed-variant",
      warning: "bg-secondary-fixed text-on-secondary-fixed-variant",
      error: "bg-error-container text-on-error-container",
    },
  },
  defaultVariants: {
    tone: "info",
  },
});

export interface AlertProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {}

/**
 * A form-level message. Errors are announced assertively so a breeder using a screen
 * reader hears "email or password is incorrect" rather than silently staying on the form.
 */
export function Alert({ className, tone, ...props }: AlertProps) {
  return (
    <div
      role={tone === "error" ? "alert" : "status"}
      className={cn(alertVariants({ tone }), className)}
      {...props}
    />
  );
}

export { alertVariants };
